class MobileMenu extends HTMLElement {
	constructor() {
		super();
		this.parents = this.querySelectorAll(".parent_link__container > span");
        this.child = this.querySelectorAll(".child_link__container .submenu");
        this.grandChildBack = this.querySelectorAll(".grandChild__container .grandChild__back");
		this.parents.forEach((e) => {
			e.addEventListener("click", this.onParentClick.bind(this));
		});
		this.child.forEach((e) => {
			e.addEventListener("click", this.onChildClick.bind(this));
		});
		this.grandChildBack.forEach((e) => {
			e.addEventListener("click", this.onBackClick.bind(this));
		});
	}
	onParentClick(e) {
        const target = e.target.dataset.target;
		this.querySelector('.parent_link__container > .is-active').classList.remove("is-active");
		e.target.classList.add("is-active");
        this.querySelector('.submenu.is-active').classList.remove('is-active');
        this.querySelector(`.submenu[data-parent='${target}']`).classList.add('is-active');
    }
    
	onChildClick(e) {
        const parent = e.target.closest('.submenu__item');
        parent.classList.add('is-active');
    }

	onBackClick(e) {
        e.stopPropagation();
        const parent = e.target.closest('.submenu__item');
        parent.classList.remove('is-active');
    }
}

customElements.define("mobile-menu", MobileMenu);